export default __webpack_public_path__ + "static/media/Mark-3-Suit-Cycles-09.5c753b61.jpg";